export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmtPay = (pay) =>
  typeof pay === 'number' ? `$${pay.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '—';

export const shareUrl = (token) => `${window.location.origin}/rate-card/${token}`;

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const el = Object.assign(document.createElement('textarea'), { value: text });
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand('copy');
    el.remove();
    return ok;
  }
};

export const errorText = (err, fallback) =>
  typeof err?.response?.data?.detail === 'string' ? err.response.data.detail : fallback;

export const pdfName = (card) =>
  ['Mighty-Link-Rate-Card', card.region, card.year].filter(Boolean).join('-').replace(/[^A-Za-z0-9-]+/g, '-') + '.pdf';

export const fmtDate = (iso) => new Date(iso).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
